import { gql } from '@apollo/client';

export default gql`
  query productProductTypesSelect {
    productProductTypes {
      id
      name
    }
  }
`;
